import React from 'react';
import { Outlet } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import Stack from '@mui/material/Stack';

import { useAuth } from '../../hooks/useAuth';

function AppLayout() {
  const { userInfo, clearSession } = useAuth();

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f3f5f8' }}>
      <AppBar color="inherit" elevation={0} position="static" sx={{ borderBottom: '1px solid rgba(15,23,42,0.08)' }}>
        <Toolbar sx={{ justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Avatar
              sx={{
                width: 36,
                height: 36,
                bgcolor: 'primary.main',
                fontSize: 16,
                fontWeight: 600,
              }}
            >
              M
            </Avatar>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                Malbon Staff Toolkit
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Shift productivity dashboard
              </Typography>
            </Box>
          </Stack>

          <Stack direction="row" spacing={1.5} alignItems="center">
            <Box textAlign="right">
              <Typography variant="subtitle2">{userInfo?.displayName || 'Retail staff'}</Typography>
              <Typography variant="body2" color="text.secondary">
                {userInfo?.username}
              </Typography>
            </Box>
            <Tooltip title="Sign out">
              <IconButton color="primary" onClick={clearSession}>
                <LogoutRoundedIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </Toolbar>
      </AppBar>

      <Container component="main" sx={{ py: 4, flex: 1, width: '100%' }}>
        <Outlet />
      </Container>
    </Box>
  );
}

export default AppLayout;

